$(function(){
	var common=require("./common.js");
	var login=require("./login.js");
	common.init();
	login.init();
	$(".m-illustration").niceScroll();
})


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/illustration.js
// module id = 0
// module chunks = 5